import { Toaster } from '@/ui/overlays/Toast';
import { ComingSoonPage } from '@/marketing/ComingSoonPage';

export default function App() {
  return (
    <>
      <Toaster />
      <ComingSoonPage />
    </>
  );
}
